export default "__VITE_ASSET__DFwcmxXo__"